import React from "react";
import { CiMenuKebab } from "react-icons/ci";

const AccountDropdown = ({ 
  accountId, 
  activeDropdown, 
  toggleDropdown, 
  options, 
  onOptionClick 
}) => {
  return (
    <div className="relative">
      <div 
        className="text-[#404040] cursor-pointer hover:text-gray-600"
        onClick={(e) => {
          e.stopPropagation();
          toggleDropdown(accountId);
        }}
      >
        <CiMenuKebab title="Options" />
      </div>
      
      {/* Dropdown Menu */}
      {activeDropdown === accountId && (
        <div className="absolute right-0 top-full mt-1 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-10">
          <div className="py-1">
            {options.map((option) => (
              <button
                key={option.key}
                onClick={(e) => {
                  e.stopPropagation();
                  onOptionClick(option.key, accountId);
                }}
                className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                  option.destructive 
                    ? 'text-red-600' 
                    : option.primary 
                    ? 'text-green-600' 
                    : 'text-gray-700'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
